"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MyMomentsList = void 0;

var _react = _interopRequireWildcard(require("react"));

require("react-virtualized/styles.css");

var _moment = _interopRequireDefault(require("moment"));

var _reactVirtualized = require("react-virtualized");

var _AutoSizer = require("../../util/AutoSizer");

var _helpers = require("../../util/helpers");

var _index = require("../../index");

var _MyMoment = require("../../molecules/MyMoment");

var _atoms = require("../../atoms");

require("./MyMomentsList.css");

var _excluded = ["moments", "userID", "className", "onClickMoment", "onAddToTraceiDClick", "onShareClick"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var getRowSettingsFor = function getRowSettingsFor(width) {
  if (width >= 1344) return {
    columns: 4
  };
  if (width >= 1008) return {
    columns: 3
  };
  if (width >= 672) return {
    columns: 2
  };
  return {
    columns: 1
  };
}; // My Moment List


var MyMomentsList = function MyMomentsList(_ref) {
  var moments = _ref.moments,
      userID = _ref.userID,
      className = _ref.className,
      onClickMoment = _ref.onClickMoment,
      onAddToTraceiDClick = _ref.onAddToTraceiDClick,
      onShareClick = _ref.onShareClick,
      props = _objectWithoutProperties(_ref, _excluded);

  // Classnames
  var cn = className ? "MyMomentsList ".concat(className) : "MyMomentList"; // Vars

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      groupedMoments = _useState2[0],
      setGroupedMoments = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = _slicedToArray(_useState3, 2),
      visualVersion = _useState4[0],
      setVisualVersion = _useState4[1];

  var _useState5 = (0, _react.useState)(0),
      _useState6 = _slicedToArray(_useState5, 2),
      numberOfRows = _useState6[0],
      setNumberOfRows = _useState6[1];

  var _useState7 = (0, _react.useState)(getRowSettingsFor(window.innerWidth).columns),
      _useState8 = _slicedToArray(_useState7, 2),
      noOfColumns = _useState8[0],
      setNoOfColumns = _useState8[1];

  var getMomentRows = function getMomentRows(moments, width) {
    var newGroupedMoments = [];
    var rowSettings = getRowSettingsFor(width);
    var maxColumns = rowSettings.columns;
    var subgroup = [];
    moments.forEach(function (moment, index) {
      var previousMoment = moments[index - 1];
      var shouldAddTitle = !previousMoment || moment.game_id !== previousMoment.game_id;

      if (shouldAddTitle) {
        // If the subgroup is not empty, add it to groupedMoments
        if (subgroup.length > 0) newGroupedMoments.push(subgroup); // Add the title

        newGroupedMoments.push([{
          kind: "title",
          content: moment
        }]); // Reset the subgroup with this moment as its first

        subgroup = [{
          kind: "moment",
          content: moment
        }];
      } else if (subgroup.length < maxColumns) {
        // If the moment should be the last of the subgroup based on column size
        subgroup.push({
          kind: "moment",
          content: moment
        });
      } else {
        // Add the subgroup
        newGroupedMoments.push(subgroup); // Reset the subgroup with this moment as its first

        subgroup = [{
          kind: "moment",
          content: moment
        }];
      }

      if (index === moments.length - 1) {
        // If this is the last item in the array, add the subgroup
        newGroupedMoments.push(subgroup);
      }
    }); // set the number of rows

    var newNoOfRows = newGroupedMoments ? newGroupedMoments.length : 0;
    setNumberOfRows(newNoOfRows);
    return newGroupedMoments;
  };

  var recalculateRowsForWidth = function recalculateRowsForWidth(width) {
    var suggestedNoColumns = getRowSettingsFor(width).columns;

    if (suggestedNoColumns !== noOfColumns) {
      setNoOfColumns(suggestedNoColumns);
      setVisualVersion(function (prevVisualVerion) {
        return prevVisualVerion + 1;
      });
    }
  };

  (0, _react.useEffect)(function () {
    // We want to group the moments into rows depending
    // on the width of the screen
    var windowWidth = window.innerWidth;
    var groupedMoments = getMomentRows(moments, windowWidth);
    setVisualVersion(function (prevVisualVerion) {
      return prevVisualVerion + 1;
    });
    setGroupedMoments(groupedMoments);
  }, [moments, noOfColumns]);

  var _rowRenderer = function rowRenderer(_ref2, width, height) {
    var index = _ref2.index,
        key = _ref2.key,
        style = _ref2.style;
    var row = groupedMoments[index];

    if (row) {
      if (row[0].kind === "title") {
        return /*#__PURE__*/_react.default.createElement(_index.Element, {
          className: "moments-row game",
          style: style,
          key: key
        }, renderTitle(row[0].content));
      } else {
        return /*#__PURE__*/_react.default.createElement(_index.Element, {
          className: "moments-row moments",
          style: style,
          key: key
        }, row.map(function (moment, momentIndex) {
          {
            return /*#__PURE__*/_react.default.createElement(_index.Element, {
              key: "mymoment-".concat(index, "-").concat(momentIndex)
            }, renderMomentRow(moment, index, momentIndex));
          }
        }));
      }
    } else {
      return null;
    }
  };

  var renderTitle = function renderTitle(moment) {
    // Get home & away teams and scores
    var awayTeam = moment === null || moment === void 0 ? void 0 : moment.away_team;
    var homeTeam = moment === null || moment === void 0 ? void 0 : moment.home_team;
    var gameResult = (0, _helpers.capitalizeFirstLetter)((0, _helpers.gameResultAsString)(homeTeam, awayTeam, true));
    var scoreString = homeTeam !== null && homeTeam !== void 0 && homeTeam.score && awayTeam !== null && awayTeam !== void 0 && awayTeam.score ? "".concat(homeTeam.score, ":").concat(awayTeam.score) : "".concat(gameResult);
    var gameTime = (0, _moment.default)(moment.start_time).format("LL");
    var updatedTimeAgo = moment ? (0, _helpers.capitalizeFirstLetter)((0, _helpers.formatUTCTimestampAsTimeAgo)(moment.start_time)) : ""; // Future: switch out start_time for update_time
    // Construct the detail string

    var details = moment.type !== "CustomUpload" ? "".concat(scoreString, " vs. ").concat(awayTeam.title) : "Uploaded ".concat(gameTime);
    return /*#__PURE__*/_react.default.createElement(_index.Column, {
      justifyContent: "flex-end"
    }, /*#__PURE__*/_react.default.createElement(_index.Label, {
      bold: true,
      color: _atoms.Color.Black
    }, details), /*#__PURE__*/_react.default.createElement(_index.Label, {
      type: _index.Label.Type.SmallBody
    }, gameTime));
  };

  var renderMomentRow = function renderMomentRow(moment, index, momentIndex) {
    return /*#__PURE__*/_react.default.createElement(_MyMoment.MyMoment, {
      theKey: "mymoment-".concat(index, "-").concat(momentIndex),
      onAddToTraceiDClick: onAddToTraceiDClick,
      onShareClick: onShareClick,
      onClickMoment: onClickMoment,
      moment: moment.content,
      userID: userID,
      index: index,
      margin: "2",
      utmCampaign: "user_playlists"
    });
  };

  var _rowHeight = function rowHeight(_ref3, width, height) {
    var index = _ref3.index;
    var rowHeight = 284;

    if (groupedMoments[index] && groupedMoments[index][0] && groupedMoments[index][0].kind === "title") {
      if (width < 541) {
        rowHeight = 80;
      } else {
        rowHeight = 64;
      }
    }

    return rowHeight;
  };

  var onScroll = function onScroll() {
    return;
  };

  return /*#__PURE__*/_react.default.createElement(_index.Element, _extends({
    className: cn
  }, props), /*#__PURE__*/_react.default.createElement(_index.Row, {
    justifyContent: "center",
    paddingBottom: "4"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
    type: _atoms.Icon.Type.Lock,
    color: _atoms.Color.Grey2,
    marginRight: "2"
  }), /*#__PURE__*/_react.default.createElement(_index.Label, {
    color: _atoms.Color.Grey2
  }, "Only you and your family can see this")), /*#__PURE__*/_react.default.createElement(_reactVirtualized.WindowScroller, null, function (_ref4) {
    var height = _ref4.height,
        scrollTop = _ref4.scrollTop;
    return /*#__PURE__*/_react.default.createElement(_AutoSizer.AutoSizer, {
      disableHeight: true
    }, function (_ref5) {
      var width = _ref5.width;
      recalculateRowsForWidth(width);
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactVirtualized.List, {
        autoHeight: true,
        key: "list-".concat(visualVersion),
        height: height,
        width: width,
        scrollTop: scrollTop,
        overscanRowCount: 6,
        onScroll: onScroll,
        scrollToIndex: 0,
        scrollToAlignmet: "center",
        rowRenderer: function rowRenderer(params) {
          return _rowRenderer(params, width, height);
        },
        rowHeight: function rowHeight(params) {
          return _rowHeight(params, width, height);
        },
        rowCount: numberOfRows
      }));
    });
  }));
};

exports.MyMomentsList = MyMomentsList;
MyMomentsList.defaultProps = {};